import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateDirectStatus = ({ directID, status }) => {
  try {
    return axios.put(
      `/api/directs/${directID}/status`,
      JSON.stringify({ Status: status })
    );
  } catch (error) {
    return error;
  }
};

export const useUpdateDirectStatus = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateDirectStatus,
    onSuccess: () => {
      enqueueSnackbar(`Direct's status successfully updated`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
